(function() {
  var DATE_REGEXP;

  if (App.angularApp == null) {
    return;
  }

  DATE_REGEXP = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(199\d|[2-9]\d{3})$/;

  App.angularApp.directive('mfIsDatePickerFormat', function() {
    return {
      require: 'ngModel',
      link: (function(_this) {
        return function(scope, element, attrs, ngModel) {
          return ngModel.$validators.mfIsDatePickerFormat = function(modelValue, viewValue) {
            if (ngModel.$isEmpty(modelValue)) {
              return true;
            }
            if (DATE_REGEXP.test(viewValue)) {
              return true;
            }
            return false;
          };
        };
      })(this)
    };
  });

}).call(this);
